import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dialog-create-tipo-movimiento',
  templateUrl: './dialog-create-tipo-movimiento.component.html',
  styleUrls: ['./dialog-create-tipo-movimiento.component.css']
})
export class DialogCreateTipoMovimientoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
